import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import type { JSX } from "react";
import DashboardPage from "@/components/dashboard/dashboard-page";
import { pathToDashboardTab } from "@/lib/dashboard/use-dashboard-access";

const DashboardLayout = (): JSX.Element => {
	const tab = useRouterState({
		select: (state) =>
			pathToDashboardTab(state.location.pathname) ??
			(state.resolvedLocation ? pathToDashboardTab(state.resolvedLocation.pathname) : null),
	});
	if (!tab) {
		return <Outlet />;
	}
	return (
		<DashboardPage tab={tab}>
			<Outlet />
		</DashboardPage>
	);
};

export const Route = createFileRoute("/_app/dashboard")({
	component: DashboardLayout,
});
